var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"fullscreen":"","persistent":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('div',{staticClass:"confirmation py-4"},[_c('div',{class:[
        'px-3 mb-0 pb-0',
        'font-weight-bold',
        { 'text-center': _vm.$vuetify.breakpoint.smAndDown },
        'text-h5',
      ]},[_vm._v(" Questionários respondidos. ")]),_c('v-icon',{staticClass:"my-8",attrs:{"color":"primary"}},[_vm._v("mdi-check-circle-outline")]),_c('img',{attrs:{"src":_vm.organization.logo,"alt":"logo"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }